import { Controller } from "@hotwired/stimulus"
import "jquery"

const HEAT_COST_DIVISOR = 70
const OVERHEAD_PER_KG_RUPEES = 52

export default class extends Controller {
  static targets = [
    "profitField",
    "finalCostField",
    "finishProductPriceField",
    "heatSelect",
    "weightField"
  ]

  connect() {
    this.finishProductPrice = 0
    this.heatCostPaisa = 0
    this.initializeCocoonCallbacks()
    this.initializeFinishProductListener()
    this.initializeHeatListener()
    this.initializeWeightListener()
    this.calculateCost()
  }

  initializeCocoonCallbacks() {
    $(this.element).on('cocoon:after-insert', () => {
      setTimeout(() => {
        this.calculateCost()
      }, 50)
    })

    $(this.element).on('cocoon:after-remove', () => {
      this.calculateCost()
    })
  }

  initializeFinishProductListener() {
    const finishProductSelect = this.element.querySelector('select[name*="[finish_product_id]"]')
    if (finishProductSelect) {
      $(finishProductSelect).on('select2:select', (e) => {
        this.handleFinishProductChange(e.params.data.id)
      })

      $(finishProductSelect).on('select2:clear', () => {
        this.finishProductPrice = 0
        this.updateFinishProductPriceDisplay()
        this.calculateCost()
      })

      finishProductSelect.addEventListener('change', (e) => {
        if (e.target.value) {
          this.handleFinishProductChange(e.target.value)
        } else {
          this.finishProductPrice = 0
          this.updateFinishProductPriceDisplay()
          this.calculateCost()
        }
      })

      if (finishProductSelect.value) {
        this.handleFinishProductChange(finishProductSelect.value)
      }
    }
  }

  initializeHeatListener() {
    if (this.hasHeatSelectTarget) {
      this.heatSelectTarget.addEventListener('change', () => {
        this.fetchHeatCost()
      })
      this.fetchHeatCost()
    }
  }

  initializeWeightListener() {
    if (this.hasWeightFieldTarget) {
      this.weightFieldTarget.addEventListener('input', () => this.calculateCost())
      this.weightFieldTarget.addEventListener('change', () => this.calculateCost())
    }
  }

  async handleFinishProductChange(productId) {
    const companyId = this.element.dataset.companyId

    if (!productId) {
      this.finishProductPrice = 0
      this.updateFinishProductPriceDisplay()
      this.calculateCost()
      return
    }

    try {
      const response = await fetch(`/api/v1/companies/${companyId}/finish_products/${productId}`)
      const data = await response.json()
      this.finishProductPrice = parseFloat(data.price) || 0
      this.updateFinishProductPriceDisplay()
      this.calculateCost()
    } catch (error) {
      console.error('Error fetching finish product price:', error)
      this.finishProductPrice = 0
      this.updateFinishProductPriceDisplay()
      this.calculateCost()
    }
  }

  updateFinishProductPriceDisplay() {
    if (this.hasFinishProductPriceFieldTarget) {
      this.finishProductPriceFieldTarget.value = this.finishProductPrice.toFixed(2)
    }
  }

  async fetchHeatCost() {
    const companyId = this.element.dataset.companyId
    const heatId = this.hasHeatSelectTarget ? this.heatSelectTarget.value : null

    if (!heatId) {
      this.heatCostPaisa = 0
      this.calculateCost()
      return
    }

    try {
      const response = await fetch(`/api/v1/companies/${companyId}/heats/${heatId}/cost`)
      const data = await response.json()
      this.heatCostPaisa = data.total_cost_paisa || 0
      this.calculateCost()
    } catch (error) {
      console.error('Error fetching heat cost:', error)
      this.heatCostPaisa = 0
      this.calculateCost()
    }
  }

  weightChanged() {
    this.calculateCost()
  }

  overheadCostChanged() {
    this.calculateCost()
  }

  calculateCost() {
    const weight = this.hasWeightFieldTarget
      ? parseFloat(this.weightFieldTarget.value) || 0
      : 0

    // Heat cost portion: (total_heat_cost / 70) * weight (result in paisa)
    const heatCostPortionPaisa = (this.heatCostPaisa / HEAT_COST_DIVISOR) * weight

    // Formula overhead: weight * 52 Rs = weight * 52 * 100 paisa
    const formulaOverheadPaisa = weight * OVERHEAD_PER_KG_RUPEES * 100

    // Custom overhead from form fields
    const overheadCostPrices = this.element.querySelectorAll(
      'input[data-overhead-cost-price], input[name*="[overhead_costs_attributes]"][name*="[price]"]'
    )
    let customOverheadPaisa = 0
    overheadCostPrices.forEach((priceField) => {
      const nestedFields = priceField.closest('.nested-fields')
      if (nestedFields) {
        const destroyField = nestedFields.querySelector('input[name*="[_destroy]"]')
        if (destroyField && destroyField.value === '1') {
          return
        }
      }
      const priceRupees = parseFloat(priceField.value) || 0
      customOverheadPaisa += priceRupees * 100
    })

    const finalCostPaisa = heatCostPortionPaisa + formulaOverheadPaisa + customOverheadPaisa
    const finalCostRupees = finalCostPaisa / 100
    const profitRupees = this.finishProductPrice - finalCostRupees

    if (this.hasFinalCostFieldTarget) {
      this.finalCostFieldTarget.value = finalCostRupees.toFixed(2)
    }

    if (this.hasProfitFieldTarget) {
      this.profitFieldTarget.value = profitRupees.toFixed(2)
    }
  }
}
